<script setup lang="ts">
import { useAttrs } from "vue";

export type CardProps = {
  variant?: "plain" | "outlined";
};

const { variant = "plain" } = defineProps<CardProps>();

const attrs = useAttrs();
</script>

<template>
  <div
    v-bind="attrs"
    :class="[
      'atom-card',
      variant === 'plain' ? 'atom-card--plain' : 'atom-card--outlined',
    ]"
  >
    <slot />
  </div>
</template>

<style lang="scss" scoped>
.atom-card {
  border-radius: 12px;
  padding: 20px;
  transition:
    box-shadow 0.2s,
    border-color 0.2s,
    background 0.2s;
  box-shadow: none;
  background: var(--clr-p1, #fff);
  border: none;

  &--plain {
    background: var(--clr-g50);
    color: #000;
    border: 1px transparent;
  }

  &--outlined {
    background: #fff;
    border: 1px solid var(--clr-p5);
    color: #000;
  }
}
</style>
